import React from 'react';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import PropTypes from 'prop-types';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import TextButton from 'Components/ComponentLibrary/Components/Uncategorized/TextButton';
import MetaField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';

import RoundedButton from 'Components/ComponentLibrary/Components/Uncategorized/RoundedButton';
import useMobileLayout from 'Hooks/useMobileLayout';
import SurveyFixedFooterActions from '../../../SurveyFixedFooterActions';
import AccountSetupSection from '../../Components/AccountSetup/AccountSetupSection';
import { useSurveyStepContext } from '../../SurveyStepContext';

const styles = (theme) => ({
  root: {},
  footer: {},
  enableButton: {
    marginTop: theme.spacing(1),
  },
  phoneInput: {
    marginTop: theme.spacing(2),
  },
});

const AccountSetupTwoFactorAuthenticationPhoneNumberLayout = ({
  classes,
}) => {
  const { onSubmit, resource } = useMetaLayoutContext();
  const { onClickNext } = useSurveyStepContext();
  const { onClickPrevious } = useSurveyStepContext();
  const isMobile = useMobileLayout();

  return (
    <div className={classes.root}>
      {/* ---------- Section title / icon / message ---------- */}
      <AccountSetupSection
        title={'Two-Factor Authentication'}
        messages={[
          'Enter your phone number.',
          'We will send a verification code.',
        ]}
        showFacetIcon
      />

      {/* ---------- Phone Number Input ---------- */}
      <MetaField
        className={classes.phoneInput}
        test={'two-factor-phone-number-input'}
        attr={'phoneNumber'}
      />

      {/* ---------- Footer (Navigator) ---------- */}
      <SurveyFixedFooterActions>
        {/* Cancel - Go back to previous step */}
        <TextButton
          onClick={onClickPrevious}
          color={'primary'}
          weight={'bold'}
          fullWidth
          size={!isMobile ? 'lg' : 'md'}
          test={'cancel-2fa-code-button'}
        >
          {'Go Back'}
        </TextButton>

        {/* Send 2FA Verification Code */}
        <RoundedButton
          disabled={!resource.isValid()}
          className={classes.enableButton}
          onClick={() => onClickNext(onSubmit)}
          color={'primary'}
          variant={'contained'}
          disableElevation
          fullWidth
          test={'send-2fa-code-button'}
        >
          {'Send verification code'}
        </RoundedButton>
      </SurveyFixedFooterActions>
    </div>
  );
};

AccountSetupTwoFactorAuthenticationPhoneNumberLayout.propTypes = {
  classes: PropTypes.object.isRequired,
};

AccountSetupTwoFactorAuthenticationPhoneNumberLayout.defaultProps = {
};

export default withStyles(styles)(AccountSetupTwoFactorAuthenticationPhoneNumberLayout);
